import {
  MenuItem as MuiMenuItem,
  MenuItemProps,
  Typography,
} from "@mui/material";

const MenuItem = ({ children, ...props }: MenuItemProps) => (
  <MuiMenuItem {...props}>
    <Typography variant="bodySecondaryReg" sx={{ color: "shades.neutral.500" }}>
      {children}
    </Typography>
  </MuiMenuItem>
);

export default MenuItem;
